export enum BookingProductStepEnum {
  Init = 0,
  ProductSelection = 10,
  ExtraProductSelection = 20,
  Authentication = 30,
  Payment = 40,
}
